import { Link } from "react-router-dom";
import { KeyRound, Phone, Mail, MapPin, Clock } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { site } from "@/config/site";
import { services } from "@/data/services";
import { bezirke } from "@/data/bezirke";
import { problems } from "@/data/problems";

export const Footer = () => {
  const { t, lang } = useLang();
  return (
    <footer className="bg-primary text-primary-foreground border-t border-primary-foreground/10">
      <div className="container py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="lg:col-span-1">
          <Link to="/" className="flex items-center gap-2 font-display text-2xl tracking-wider mb-4">
            <span className="grid place-items-center w-9 h-9 rounded-md bg-gradient-accent">
              <KeyRound className="w-5 h-5 text-accent-foreground" />
            </span>
            SCHLÜSSEL<span className="text-accent-on-dark">DIENST</span>
          </Link>
          <p className="text-primary-foreground/70 text-sm mb-4 max-w-xs">{t("footer.tagline")}</p>
          <p className="text-xs text-primary-foreground/50">{site.legalName}</p>
        </div>

        <div>
          <h4 className="font-display text-lg tracking-wide mb-4 text-accent-on-dark">{t("footer.services")}</h4>
          <ul className="space-y-2 text-primary-foreground/70 text-sm">
            {services.map((s) => (
              <li key={s.slug}>
                <Link to={`/leistungen/${s.slug}`} className="hover:text-accent transition-colors">
                  {lang === "de" ? s.titleDe : s.titleEn}
                </Link>
              </li>
            ))}
            <li className="pt-2 border-t border-primary-foreground/10 mt-2">
              <Link to="/probleme" className="hover:text-accent transition-colors font-semibold">
                {t("nav.probleme")} →
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg tracking-wide mb-4 text-accent-on-dark">{t("footer.bezirke")}</h4>
          <ul className="grid grid-cols-2 gap-x-3 gap-y-1.5 text-primary-foreground/70 text-sm">
            {bezirke.map((b) => (
              <li key={b.slug}>
                <Link to={`/bezirke/${b.slug}`} className="hover:text-accent transition-colors">
                  {b.plz}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg tracking-wide mb-4 text-accent-on-dark">{t("footer.contact")}</h4>
          <ul className="space-y-3 text-primary-foreground/80 text-sm">
            <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-accent shrink-0" /><a href={site.phoneHref} className="hover:text-accent">{site.phoneDisplay}</a></li>
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-accent shrink-0" /><a href={`mailto:${site.email}`} className="hover:text-accent break-all">{site.email}</a></li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-accent shrink-0" />{site.address}</li>
            <li className="flex items-start gap-2"><Clock className="w-4 h-4 mt-0.5 text-accent shrink-0" />24/7</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-primary-foreground/10 py-6">
        <div className="container flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-primary-foreground/50">
          <p>© {new Date().getFullYear()} {site.legalName}. Alle Rechte vorbehalten.</p>
          <div className="flex items-center gap-4">
            <Link to="/preise" className="hover:text-accent">Preise</Link>
            <Link to="/impressum" className="hover:text-accent">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-accent">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};